import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom'
import BlogSidebar from '../BlogSidebar/BlogSidebar'
import { getNewsBySlug } from '../../api/backend'

const BlogSingle = (props) => {

    const { slug } = useParams()
    const [data, setData] = useState({ news: null, prev: null, next: null })
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setLoading(true)
        getNewsBySlug(slug)
            .then(res => setData(res))
            .catch(err => console.error('Errore caricamento news:', err))
            .finally(() => setLoading(false))
    }, [slug])

    const submitHandler = (e) => {
        e.preventDefault()
    }

    if (loading) {
        return (
            <section className="wpo-blog-single-section section-padding">
                <div className="container"><p>Caricamento articolo...</p></div>
            </section>
        )
    }

    const { news: BlogDetails, prev: prevBlog, next: nextBlog } = data

    if (!BlogDetails) {
        return (
            <section className="wpo-blog-single-section section-padding">
                <div className="container"><p>Articolo non trovato.</p></div>
            </section>
        )
    }

    return (
        <section className="wpo-blog-single-section section-padding">
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-8 col-12 ${props.blRight}`}>
                        <div className="wpo-blog-content">
                            <div className="post format-standard-image">
                                {BlogDetails.image_url && (
                                    <div className="entry-media">
                                        <img src={BlogDetails.image_url} alt={BlogDetails.title} />
                                    </div>
                                )}
                                <div className="entry-meta">
                                    <ul>
                                        <li><i className="fi flaticon-user"></i> By <Link to={`/blog-single/${BlogDetails.slug}`}>{BlogDetails.author}</Link></li>
                                        <li><i className="fi flaticon-calendar"></i> {BlogDetails.formatted_date}</li>
                                    </ul>
                                </div>
                                <h2>{BlogDetails.title}</h2>
                                {BlogDetails.subtitle && <h3>{BlogDetails.subtitle}</h3>}
                                {BlogDetails.content && BlogDetails.content[0] && (
                                    <div dangerouslySetInnerHTML={{ __html: BlogDetails.content[0] }} />
                                )}
                            </div>

                            <div className="tag-share clearfix">
                                <div className="tag">
                                    <span>Tag: </span>
                                    <ul>
                                        {BlogDetails.tags && BlogDetails.tags.map((tag, i) => (
                                            <li key={i}><Link to={`/blog/tag/${encodeURIComponent(tag.name)}`}>{tag.name}</Link></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="tag-share-s2 clearfix">
                                <div className="tag">
                                    <span>Share: </span>
                                    <a href="#" onClick={e => e.preventDefault()}>Facebook</a>
                                    <a href="#" onClick={e => e.preventDefault()}>Linkedin</a>
                                </div>
                            </div>

                            <div className="more-posts">
                                <div className="previous-post">
                                    {prevBlog ? (
                                        <Link to={`/blog-single/${prevBlog.slug}`}>
                                            <span className="post-control-link">Articolo Precedente</span>
                                            <span className="post-name">{prevBlog.title}</span>
                                        </Link>
                                    ) : (
                                        <span className="post-control-link text-muted">Primo articolo</span>
                                    )}
                                </div>
                                <div className="next-post">
                                    {nextBlog ? (
                                        <Link to={`/blog-single/${nextBlog.slug}`}>
                                            <span className="post-control-link">Articolo Successivo</span>
                                            <span className="post-name">{nextBlog.title}</span>
                                        </Link>
                                    ) : (
                                        <span className="post-control-link text-muted">Ultimo articolo</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <BlogSidebar blLeft={props.blLeft} />
                </div>
            </div>
        </section>
    )
}

export default BlogSingle;